import React, { Component } from 'react';
import { BasicSetup } from 'Components/basicsetup/BasicSetup';

class AllergenSetup extends Component {
  render() {
    return (
      <BasicSetup
        resourcename="allergen"
        humanname="Allergen"
        blockEditFromId={1}
        blockEditToId={99}
        sortById={true}
        showId={true}
        {...this.props}
      />
    );
  }
}

export { AllergenSetup };



// WEBPACK FOOTER //
// ./src/pages/allergensetup/AllergenSetup.js